<fs-label-field>
  <mat-checkbox
    [(ngModel)]="data.attribute.configs.visibleOnList">
    {{ data.field?.label }}
  </mat-checkbox>
</fs-label-field>
